<template>
  <v-app-bar
    absolute
    color="transparent"
    flat
    height="85"
  >
    <v-container class="px-0 text-right d-flex align-center">
      <v-toolbar-title
        class="font-weight-light hidden-xs-only"
        v-text="title"
      />

      <v-spacer />

      <v-btn
        v-for="(item, i) in items"
        :key="i"
        :to="item.to"
        min-height="48"
        min-width="40"
        text
      >
        <v-icon
          :left="$vuetify.breakpoint.mdAndUp"
          size="20"
          v-text="item.icon"
        />

        <span
          class="hidden-sm-and-down"
          v-text="item.text"
        />
      </v-btn>
      <v-menu
        v-if="displayUser"
        bottom
        left
        min-width="200"
        offset-y
        origin="top right"
        transition="scale-transition"
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            class="ml-2"
            min-width="0"
            text
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>

        <v-list
          :tile="false"
          flat
          nav
        >
          <v-list-item v-text="email" />
          <amplify-sign-out />
        </v-list>
      </v-menu>
    </v-container>
  </v-app-bar>
</template>

<script>
  import { Auth } from 'aws-amplify'
  export default {
    name: 'PagesCoreAppBar',

    data: () => ({
      items: [
        {
          icon: 'mdi-view-dashboard',
          text: 'PDF Brander',
          to: '/',
        },
        {
          icon: 'mdi-help-circle-outline',
          text: 'Help',
          to: '/help',
        },
        {
          icon: 'mdi-information-outline',
          text: 'About',
          to: '/about',
        },
        {
          icon: 'mdi-page-layout-header',
          text: 'Demo',
          to: '/demo',
        },
      ],
      titles: {
        '/': 'PDF Brander',
        '/about': 'About',
        '/help': 'Help',
        '/demo': 'Demo',
      },
      displayUser: false,
    }),

    computed: {
      title () {
        return this.titles[this.$route.path]
      },
      email () {
        return Auth.user.attributes.email
      },
    },
    created () {
      Auth.currentAuthenticatedUser().then(data => {
        if (data && data.signInUserSession) {
          this.displayUser = true
        }
      }).catch((e) => {
        this.displayUser = false
      })
    },
    beforeUpdate () {
      Auth.currentAuthenticatedUser().then(data => {
        if (data && data.signInUserSession) {
          this.displayUser = true
        }
      }).catch((e) => {
        this.displayUser = false
      })
    },
  }
</script>
